"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadSidebarForm = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const DownloadSidebarForm = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, "Select download options"),
    react_1.default.createElement("p", { className: 'large' }, props.formSubText),
    props.formComponent));
exports.DownloadSidebarForm = DownloadSidebarForm;
